"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var LoadingErrorDisclaimer = props => {
  var classes = (0, _styles.default)();
  var {
    failedTarget,
    error,
    reportError
  } = props;
  _react.default.useEffect(() => {
    // Report error in the background.
    reportError(error, {
      metaData: {
        errorThrownOn: failedTarget
      }
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.errorContainer
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: 'textSecondary',
    className: classes.errorText
  }, "Error loading ", failedTarget, ". Please reload the page and try again."));
};
var _default = exports.default = LoadingErrorDisclaimer;